module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/logo-bb5c7c5a2bb907059cffd6047161226a.png";